/*-------------------------------------------------------------------
|  Function socialSvg
|
|  Purpose: Put an SVG image inline in the HTML, so we can style it in CSS
|
|  Returns:  OBJECT
*-------------------------------------------------------------------*/

function MuskSvg() {
  return (
    <>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="currentColor"
          d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
        ></path>
      </svg>
    </>
  );
}

function EmailSvg() {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22H17V20H12C7.66 20 4 16.34 4 12C4 7.66 7.66 4 12 4C16.34 4 20 7.66 20 12V13.43C20 14.22 19.29 15 18.5 15C17.71 15 17 14.22 17 13.43V12C17 9.24 14.76 7 12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C13.38 17 14.64 16.44 15.54 15.53C16.19 16.42 17.31 17 18.5 17C20.47 17 22 15.4 22 13.43V12C22 6.48 17.52 2 12 2ZM12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15Z"
          fill="currentColor"
        />
      </svg>
    </>
  );
}

function LinkSvg() {
  return (
    <>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.0256 17.143L10.2899 17.8787C9.11829 19.0503 7.21879 19.0503 6.04722 17.8787L5.59012 17.4216C4.41855 16.25 4.41855 14.3505 5.59012 13.179L8.90425 9.86482C10.0758 8.69325 11.9753 8.69325 13.1469 9.86482L13.3754 10.0934"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M12.4433 6.32578L13.179 5.59006C14.3506 4.41849 16.2501 4.41849 17.4217 5.59006L17.8788 6.04716C19.0503 7.21873 19.0503 9.11823 17.8787 10.2898L14.5646 13.6039C13.393 14.7755 11.4936 14.7755 10.322 13.6039L10.0934 13.3754"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </svg>
    </>
  );
}

function LinkedInSvg() {
  return (
    <>
      <svg
        fill="none"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      >
        <path
          d="M116.504,500.219V170.654H6.975v329.564H116.504
        				L116.504,500.219z M61.751,125.674c38.183,0,61.968-25.328,61.968-56.953c-0.722-32.328-23.785-56.941-61.252-56.941
        				C24.994,11.781,0.5,36.394,0.5,68.722c0,31.625,23.772,56.953,60.53,56.953H61.751L61.751,125.674z M177.124,500.219
        				c0,0,1.437-298.643,0-329.564H286.67v47.794h-0.727c14.404-22.49,40.354-55.533,99.44-55.533
        				c72.085,0,126.116,47.103,126.116,148.333v188.971H401.971V323.912c0-44.301-15.848-74.531-55.497-74.531
        				c-30.254,0-48.284,20.38-56.202,40.08c-2.897,7.012-3.602,16.861-3.602,26.711v184.047H177.124L177.124,500.219z"
          fill="currentColor"
        ></path>
      </svg>
    </>
  );
}

function RedditSvg() {
  return (
    <>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 100 88"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.397,57.233C3.438,54.886 0,49.81 0,43.93C0,35.823 6.537,29.24 14.588,29.24C17.945,29.24 21.039,30.385 23.505,32.307C30.139,28.16 38.5,25.535 47.647,25.144C47.646,25.129 47.646,25.114 47.646,25.099C47.646,16.358 54.268,9.142 62.724,8.272C63.704,3.551 67.865,0 72.842,0C78.548,0 83.179,4.664 83.179,10.409C83.179,16.154 78.548,20.818 72.842,20.818C67.956,20.818 63.857,17.396 62.781,12.805C56.774,13.624 52.129,18.822 52.129,25.093C52.129,25.106 52.129,25.119 52.128,25.132C61.372,25.479 69.827,28.105 76.525,32.282C78.987,30.375 82.068,29.24 85.412,29.24C93.463,29.24 100,35.823 100,43.93C100,49.782 96.595,54.839 91.673,57.2C91.212,74.258 72.731,88 50.035,88C27.353,88 8.882,74.276 8.397,57.233ZM37.726,53.541L37.726,53.547C37.969,48.258 34.851,43.843 30.761,43.843C26.672,43.843 23.161,47.303 22.918,52.591C22.675,57.88 25.792,60.752 29.882,60.752C33.972,60.752 37.483,58.83 37.726,53.541ZM62.35,53.541C62.593,58.83 66.104,60.752 70.193,60.752C74.283,60.752 77.401,57.88 77.158,52.591C76.915,47.303 73.404,43.843 69.314,43.843C65.224,43.843 62.107,48.258 62.35,53.547L62.35,53.541ZM50.035,64.864C44.968,64.864 40.109,65.115 35.62,65.575C34.851,65.651 34.365,66.454 34.666,67.171C37.182,73.223 43.117,77.475 50.035,77.475C56.953,77.475 62.893,73.223 65.404,67.171C65.705,66.454 65.213,65.651 64.449,65.575C59.955,65.115 55.102,64.864 50.035,64.864Z"
          fill="currentColor"
        />
      </svg>
    </>
  );
}

export { MuskSvg, EmailSvg, LinkSvg, LinkedInSvg, RedditSvg };
